// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__aqyUh","subheader":"ReorderModal_subheader__2879B","listWrap":"ReorderModal_listWrap__XsXh8"};